var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "DropdownArrow",

    getDefaultProps () {
        return {"width":"12px","height":"7px","viewBox":"0 0 12 7","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>Artboard 1</title>
  <desc>Created with Sketch.</desc>
  <defs/>
  <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="Artboard-1">
      <g id="Group">
        <polygon id="Triangle-1-Copy" fill="#EAEAEA" transform="translate(6.000000, 3.500000) rotate(-180.000000) translate(-6.000000, -3.500000) " points="6 -1.17030568e-14 12 7 6.55885602e-15 7"/>
        <polygon id="Triangle-1" fill="#FFFFFF" transform="translate(6.000000, 3.000000) rotate(-180.000000) translate(-6.000000, -3.000000) " points="6 -1.00311916e-14 11 6 1 6"/>
      </g>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./assets/images/dropdown-arrow.svg
 **/